import { ROUTE_KEYS } from './routeKeys';

import { FormationContinue } from '../pages/FormationPages/FormationContinue';
import { InscriptionSuccess } from '../pages/InscriptionSuccess';
import { FormationInitialeSuccess } from '../pages/FormationInitialeSuccess';
import { FicheInscriptionPreview } from '../pages/FicheInscriptionPages/FicheInscriptionPreview';
import { FicheInscription } from '../pages/FicheInscriptionPages/FicheInscription';
import { FicheInscriptions } from '../pages/FicheInscriptionPages/FicheInscriptions';
import { FormationInitiale } from '../pages/FormationPages/FormationInitiale';
import { FormationEntry } from '../pages/FormationPages/FormationEntry';
import { FormationEntries } from '../pages/FormationPages/FormationEntries';
import { DroitImageForm } from '../pages/DroitImagePages/DroitImageForm';
import { DroitImagePreview } from '../pages/DroitImagePages/DroitImagePreview/DroitImagePreview';
import { DroitImageEntries } from '../pages/DroitImagePages/DroitImageEntries';
import { FicheRenseignement } from '../pages/FormationPages/FicheRenseignement';
import { FicheRenseignementSuccess } from '../pages/FicheRenseignementSuccess';
import { FicheRenseignementEntries } from '../pages/FormationPages/FicheRenseignementEntries';
import { FicheRenseignementPreview } from '../pages/FormationPages/FicheRenseignementPreview';

const ROUTE_ELEMENTS: Record<
    (typeof ROUTE_KEYS)[number],
    { element: JSX.Element; hideFrieze?: boolean }
> = {
    DROIT_IMAGE_ENTRIES: { element: <DroitImageEntries /> },
    DROIT_IMAGE_FORM: { element: <DroitImageForm /> },
    DROIT_IMAGE_PREVIEW: { element: <DroitImagePreview /> },
    FICHE_INSCRIPTION: { element: <FicheInscription /> },
    FICHE_RENSEIGNEMENT: { element: <FicheRenseignement /> },
    FICHE_RENSEIGNEMENT_ENTRIES: { element: <FicheRenseignementEntries /> },
    FICHE_INSCRIPTION_PREVIEW: { element: <FicheInscriptionPreview /> },
    FICHE_INSCRIPTION_ENTRIES: { element: <FicheInscriptions /> },
    FORMATION_INITIALE: { element: <FormationInitiale /> },
    FORMATION_CONTINUE: { element: <FormationContinue /> },
    FORMATION_ENTRY: { element: <FormationEntry />, hideFrieze: true },
    FORMATION_ENTRIES: { element: <FormationEntries />, hideFrieze: true },
    INSCRIPTION_SUCCESS: { element: <InscriptionSuccess /> },
    FORMATION_INITIALE_SUCCESS: { element: <FormationInitialeSuccess /> },
    FICHE_RENSEIGNEMENT_SUCCESS: { element: <FicheRenseignementSuccess /> },
    FICHE_RENSEIGNEMENT_PREVIEW: { element: <FicheRenseignementPreview /> },
};

export { ROUTE_ELEMENTS };
